import { render } from "./FollowersContent.vue?vue&type=template&id=6e1e3760"
import script from "./FollowersContent.vue?vue&type=script&lang=js"
export * from "./FollowersContent.vue?vue&type=script&lang=js"

import "./FollowersContent.vue?vue&type=style&index=0&id=6e1e3760&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__